import React, { ComponentProps, useMemo, JSX } from 'react';

import { Text } from '@adsk/alloy-react-box';

import MentionCallout from './MentionCallout';
import { MENTION_TAG_REGEX } from '../consts';
import stringRegexReplace from '../utils/stringRegexReplace';

export type TextProps = { style?: React.CSSProperties; className?: string } & {
  value: string;
  regex?: RegExp;
  renderCallout?: (props: ComponentProps<typeof MentionCallout>) => JSX.Element;
};

const MentionText = React.forwardRef<HTMLSpanElement, TextProps>(
  (
    {
      className,
      style,
      value,
      regex = MENTION_TAG_REGEX,
      renderCallout = (rest: ComponentProps<typeof MentionCallout>) => (
        <MentionCallout {...rest} />
      ),
      ...props
    },
    ref,
  ) => {
    const replacedStrings = useMemo(
      () =>
        stringRegexReplace(value, regex, (mention, index) =>
          renderCallout({
            key: `${mention.id}_${index}`,
            mention,
          }),
        ),
      [regex, renderCallout, value],
    );
    return (
      <Text
        ref={ref}
        className={className}
        style={{ ...style, whiteSpace: 'pre-wrap' }}
        {...props}
      >
        {replacedStrings}
      </Text>
    );
  },
);

MentionText.displayName = 'MentionText';

export default MentionText;
